import type { Locale } from '@/types/website'

/**
 * Интерфейсийн бичвэрийн толь.
 *
 * ⚠️ CMS-ийн АГУУЛГА энд ОРОХГҮЙ — тэр нь `/api/website/v1`-ээс хэл тус
 * бүрээр ирдэг. Энд зөвхөн кодод суусан, админаас засагддаггүй товч,
 * шошго, төлөвийн мөрүүд байна: өмнө нь эдгээр нь монголоор хатуу
 * бичигдсэн байсан тул `en`/`ko` сонгоход интерфейс хагас монгол үлддэг
 * байв.
 *
 * Шинэ мөр нэмэхдээ ГУРВАН хэл дээр нь нэмнэ — `Dictionary` төрөл нь
 * дутууг compile үедээ барина.
 */
const mn = {
  common: {
    all: 'Бүгд',
    search: 'Хайх',
    details: 'Дэлгэрэнгүй',
    menu: 'Цэс',
    closeSelection: 'Сонголтыг хаах',
    manufacturer: 'Үйлдвэрлэгч',
    allBrands: 'Бүх брэнд',
    home: 'Нүүр хуудас'
  },
  brands: {
    featuredHeading: 'Онцлох брэндүүд ⚡',
    featuredBadge: 'Онцлох',
    featuredDescription:
      'Дэлхийн тэргүүлэх үйлдвэрлэгчидтэй хамтран Монголын зах зээлд түгээж буй брэндүүдээс онцлон сонгов. Карт дээр дарж танилцуулга, бүтээгдэхүүний жагсаалттай нь танилцана уу.',
    otherBrands: 'Брэндүүд',
    empty: 'Нийтлэгдсэн брэнд алга байна.',
    emptyForManufacturer: 'Энэ үйлдвэрлэгчийн брэнд олдсонгүй.',
    ofManufacturer: '-ийн брэндүүд',
    seeAll: 'бүгдийг харах'
  },
  products: {
    heading: 'Бүтээгдэхүүн',
    searchPlaceholder: 'Бараа хайх...',
    allCategories: 'Бүх ангилал',
    sortNameAsc: 'Нэр А–Я',
    sortNameDesc: 'Нэр Я–А',
    grid: 'Сүлжээ',
    list: 'Жагсаалт',
    empty: 'Бараа олдсонгүй.',
    countSuffix: 'нэр төрөл',
    noImage: 'Зураггүй'
  },
  jobs: {
    heading: 'Нээлттэй ажлын байр',
    openCount: 'байр нээлттэй байна.',
    empty: 'Нээлттэй ажлын байр одоогоор алга байна.',
    apply: 'Анкет илгээх',
    vacancies: 'орон тоо',
    until: 'хүртэл',
    employment: {
      full_time: 'Бүтэн цагийн',
      part_time: 'Хагас цагийн',
      contract: 'Гэрээт',
      internship: 'Дадлага',
      temporary: 'Түр'
    }
  },
  news: {
    other: 'Бусад мэдээ'
  },
  coverage: {
    hint: 'Аймаг дээр дарж дэлгэрэнгүйг нь харна уу.',
    province: 'Аймаг',
    district: 'Дүүрэг',
    customer: 'Харилцагч',
    contracted: 'Гэрээт',
    zone: 'Бүс',
    total: 'Нийт',
    mapLabel: 'Монгол Улсын аймгуудаар борлуулалтын хамрах хүрээ'
  },
  contact: {
    name: 'Нэр',
    company: 'Байгууллага',
    email: 'Имэйл',
    phone: 'Утас',
    subject: 'Сэдэв',
    message: 'Зурвас',
    namePlaceholder: 'Таны нэр',
    companyPlaceholder: 'Байгууллагын нэр',
    subjectPlaceholder: 'Хамтран ажиллах санал',
    reachHint: 'Имэйл эсвэл утасны аль нэгийг заавал үлдээнэ үү.',
    submit: 'Илгээх',
    sending: 'Илгээж байна...',
    thanks: 'Баярлалаа!',
    error: 'Хүсэлт илгээхэд алдаа гарлаа. Дахин оролдоно уу.'
  },
  /*
   * АЖЛЫН БАЙРНЫ АНКЕТ.
   *
   * ⚠️ ГУРВАН ХЭЛЭНД ЧХ МОНГОЛООР — ЗОРИУД. Хуучин Laravel маягт
   * (`/anket/create`) бүх зочинд монголоор үйлчилдэг байсан бөгөөд
   * анкетыг ХН монголоор уншиж, монголоор эргэж холбогддог. Орчуулга
   * нэмбэл өргөдөгч англиар бөглөж, ХН талд ойлгомжгүй болно.
   *
   * ⇒ Хэл нэмэх шийдвэр гарвал ЭНД гурвуулангийнх нь текстийг сольж,
   *   сервер талын валидацын мессежийг ч (`website-application.dto.ts`)
   *   хамт орчуулна.
   */
  apply: {
    title: 'Ажлын байрны анкет',
    subtitle: 'Бүх талбарыг бөглөх шаардлагагүй — одоор тэмдэглэснийг л заавал бөглөнө.',
    forJob: 'Сонгосон ажлын байр',
    personal: 'Хувийн мэдээлэл',
    lastName: 'Овог',
    firstName: 'Нэр',
    urgiinOvog: 'Ургийн овог',
    register: 'Регистр',
    gender: 'Хүйс',
    male: 'Эрэгтэй',
    female: 'Эмэгтэй',
    birthday: 'Төрсөн огноо',
    marital: 'Гэр бүлийн байдал',
    single: 'Гэрлээгүй',
    married: 'Гэрлэсэн',
    divorced: 'Салсан',
    widowed: 'Бэлэвсэн',
    choose: 'Сонгох...',
    contactSection: 'Холбоо барих',
    mobilePhone: 'Гар утас',
    email: 'Имэйл',
    address: 'Гэрийн хаяг',
    emergencyContact: 'Яаралтай үед холбоо барих',
    emergencyPhone: 'Яаралтай үеийн утас',
    request: 'Ажлын хүсэлт',
    expectedSalary: 'Хүсэж буй цалин (₮)',
    hasAcquaintance: 'Максимуст танил хүн ажилладаг',
    acquaintanceDescription: 'Танилын нэр, албан тушаал',
    hasDisability: 'Хөгжлийн бэрхшээлтэй',
    disabilityDescription: 'Тайлбар',
    education: 'Боловсрол',
    school: 'Сургууль',
    degree: 'Зэрэг',
    fieldOfStudy: 'Мэргэжил',
    startDate: 'Эхэлсэн',
    endDate: 'Дууссан',
    experience: 'Ажлын туршлага',
    company: 'Байгууллага',
    position: 'Албан тушаал',
    salary: 'Цалин',
    leavingReason: 'Гарсан шалтгаан',
    jobDescription: 'Гүйцэтгэсэн ажил',
    family: 'Гэр бүлийн байдал',
    fullName: 'Бүтэн нэр',
    relationship: 'Таны юу болох',
    birthDate: 'Төрсөн огноо',
    phone: 'Утас',
    occupation: 'Мэргэжил',
    attachments: 'Хавсралт',
    avatar: 'Зураг',
    avatarHint: 'JPG, PNG, WEBP · 5 МБ хүртэл',
    cv: 'CV файл',
    cvHint: 'Зөвхөн PDF · 5 МБ хүртэл',
    coverLetter: 'Нэмэлт тайлбар',
    addRow: 'Мөр нэмэх',
    removeRow: 'Мөр хасах',
    noRows: 'Мөр нэмэгдээгүй байна',
    submit: 'Анкет илгээх',
    sending: 'Илгээж байна...',
    thanks: 'Анкет хүлээн авлаа!',
    thanksHint: 'Хүний нөөцийн алба таны анкеттай танилцаад эргэн холбогдоно.',
    error: 'Анкет илгээхэд алдаа гарлаа. Дахин оролдоно уу.',
    backToCareers: 'Ажлын байрны жагсаалт руу'
  },
  footer: {
    tagline: 'Дэлхийн шилдэг брэндүүдийг Монголын хэрэглэгчдэд хүргэдэг түгээлтийн сүлжээ.',
    copyright: 'MAXIMUS. Бүх эрх хуулиар хамгаалагдсан.',
    note: 'maximus.mn',
    social: 'Сошиал'
  },
  notFound: {
    title: 'Хуудас олдсонгүй',
    description: 'Таны хайж буй хуудас байхгүй эсвэл хаяг нь өөрчлөгдсөн байна.'
  }
}

export type Dictionary = typeof mn

const en: Dictionary = {
  common: {
    all: 'All',
    search: 'Search',
    details: 'Details',
    menu: 'Menu',
    closeSelection: 'Clear selection',
    manufacturer: 'Manufacturer',
    allBrands: 'All brands',
    home: 'Home'
  },
  brands: {
    featuredHeading: 'Featured brands ⚡',
    featuredBadge: 'Featured',
    featuredDescription:
      'A selection of the brands we distribute in Mongolia in partnership with leading international manufacturers. Open a card for the brand story and its product range.',
    otherBrands: 'Brands',
    empty: 'No published brands yet.',
    emptyForManufacturer: 'No brands found for this manufacturer.',
    ofManufacturer: ' brands',
    seeAll: 'see all'
  },
  products: {
    heading: 'Products',
    searchPlaceholder: 'Search products...',
    allCategories: 'All categories',
    sortNameAsc: 'Name A–Z',
    sortNameDesc: 'Name Z–A',
    grid: 'Grid',
    list: 'List',
    empty: 'No products found.',
    countSuffix: 'items',
    noImage: 'No image'
  },
  jobs: {
    heading: 'Open positions',
    openCount: 'positions open.',
    empty: 'There are no open positions right now.',
    apply: 'Apply',
    vacancies: 'openings',
    until: 'until',
    employment: {
      full_time: 'Full time',
      part_time: 'Part time',
      contract: 'Contract',
      internship: 'Internship',
      temporary: 'Temporary'
    }
  },
  news: {
    other: 'More news'
  },
  coverage: {
    hint: 'Select a province to see its details.',
    province: 'Province',
    district: 'District',
    customer: 'Customers',
    contracted: 'Contracted',
    zone: 'Zone',
    total: 'Total',
    mapLabel: 'Sales coverage across the provinces of Mongolia'
  },
  contact: {
    name: 'Name',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    subject: 'Subject',
    message: 'Message',
    namePlaceholder: 'Your name',
    companyPlaceholder: 'Company name',
    subjectPlaceholder: 'Partnership enquiry',
    reachHint: 'Please leave either an email or a phone number.',
    submit: 'Send',
    sending: 'Sending...',
    thanks: 'Thank you!',
    error: 'The message could not be sent. Please try again.'
  },
  /*
   * АЖЛЫН БАЙРНЫ АНКЕТ.
   *
   * ⚠️ ГУРВАН ХЭЛЭНД ЧХ МОНГОЛООР — ЗОРИУД. Хуучин Laravel маягт
   * (`/anket/create`) бүх зочинд монголоор үйлчилдэг байсан бөгөөд
   * анкетыг ХН монголоор уншиж, монголоор эргэж холбогддог. Орчуулга
   * нэмбэл өргөдөгч англиар бөглөж, ХН талд ойлгомжгүй болно.
   *
   * ⇒ Хэл нэмэх шийдвэр гарвал ЭНД гурвуулангийнх нь текстийг сольж,
   *   сервер талын валидацын мессежийг ч (`website-application.dto.ts`)
   *   хамт орчуулна.
   */
  apply: {
    title: 'Ажлын байрны анкет',
    subtitle: 'Бүх талбарыг бөглөх шаардлагагүй — одоор тэмдэглэснийг л заавал бөглөнө.',
    forJob: 'Сонгосон ажлын байр',
    personal: 'Хувийн мэдээлэл',
    lastName: 'Овог',
    firstName: 'Нэр',
    urgiinOvog: 'Ургийн овог',
    register: 'Регистр',
    gender: 'Хүйс',
    male: 'Эрэгтэй',
    female: 'Эмэгтэй',
    birthday: 'Төрсөн огноо',
    marital: 'Гэр бүлийн байдал',
    single: 'Гэрлээгүй',
    married: 'Гэрлэсэн',
    divorced: 'Салсан',
    widowed: 'Бэлэвсэн',
    choose: 'Сонгох...',
    contactSection: 'Холбоо барих',
    mobilePhone: 'Гар утас',
    email: 'Имэйл',
    address: 'Гэрийн хаяг',
    emergencyContact: 'Яаралтай үед холбоо барих',
    emergencyPhone: 'Яаралтай үеийн утас',
    request: 'Ажлын хүсэлт',
    expectedSalary: 'Хүсэж буй цалин (₮)',
    hasAcquaintance: 'Максимуст танил хүн ажилладаг',
    acquaintanceDescription: 'Танилын нэр, албан тушаал',
    hasDisability: 'Хөгжлийн бэрхшээлтэй',
    disabilityDescription: 'Тайлбар',
    education: 'Боловсрол',
    school: 'Сургууль',
    degree: 'Зэрэг',
    fieldOfStudy: 'Мэргэжил',
    startDate: 'Эхэлсэн',
    endDate: 'Дууссан',
    experience: 'Ажлын туршлага',
    company: 'Байгууллага',
    position: 'Албан тушаал',
    salary: 'Цалин',
    leavingReason: 'Гарсан шалтгаан',
    jobDescription: 'Гүйцэтгэсэн ажил',
    family: 'Гэр бүлийн байдал',
    fullName: 'Бүтэн нэр',
    relationship: 'Таны юу болох',
    birthDate: 'Төрсөн огноо',
    phone: 'Утас',
    occupation: 'Мэргэжил',
    attachments: 'Хавсралт',
    avatar: 'Зураг',
    avatarHint: 'JPG, PNG, WEBP · 5 МБ хүртэл',
    cv: 'CV файл',
    cvHint: 'Зөвхөн PDF · 5 МБ хүртэл',
    coverLetter: 'Нэмэлт тайлбар',
    addRow: 'Мөр нэмэх',
    removeRow: 'Мөр хасах',
    noRows: 'Мөр нэмэгдээгүй байна',
    submit: 'Анкет илгээх',
    sending: 'Илгээж байна...',
    thanks: 'Анкет хүлээн авлаа!',
    thanksHint: 'Хүний нөөцийн алба таны анкеттай танилцаад эргэн холбогдоно.',
    error: 'Анкет илгээхэд алдаа гарлаа. Дахин оролдоно уу.',
    backToCareers: 'Ажлын байрны жагсаалт руу'
  },
  footer: {
    tagline: 'A distribution network bringing the world’s leading brands to consumers across Mongolia.',
    copyright: 'MAXIMUS. All rights reserved.',
    note: 'maximus.mn',
    social: 'Social'
  },
  notFound: {
    title: 'Page not found',
    description: 'This page does not exist or its address has changed.'
  }
}

const ko: Dictionary = {
  common: {
    all: '전체',
    search: '검색',
    details: '자세히',
    menu: '메뉴',
    closeSelection: '선택 해제',
    manufacturer: '제조사',
    allBrands: '전체 브랜드',
    home: '홈'
  },
  brands: {
    featuredHeading: '주요 브랜드 ⚡',
    featuredBadge: '주요',
    featuredDescription:
      '세계 유수의 제조사와 협력하여 몽골 시장에 유통하는 브랜드를 엄선했습니다. 카드를 눌러 브랜드 소개와 제품을 확인하세요.',
    otherBrands: '브랜드',
    empty: '게시된 브랜드가 없습니다.',
    emptyForManufacturer: '이 제조사의 브랜드를 찾을 수 없습니다.',
    ofManufacturer: ' 브랜드',
    seeAll: '전체 보기'
  },
  products: {
    heading: '제품',
    searchPlaceholder: '제품 검색...',
    allCategories: '전체 카테고리',
    sortNameAsc: '이름 오름차순',
    sortNameDesc: '이름 내림차순',
    grid: '그리드',
    list: '목록',
    empty: '제품을 찾을 수 없습니다.',
    countSuffix: '개',
    noImage: '이미지 없음'
  },
  jobs: {
    heading: '채용 공고',
    openCount: '개의 공고가 열려 있습니다.',
    empty: '현재 채용 중인 공고가 없습니다.',
    apply: '지원하기',
    vacancies: '명',
    until: '까지',
    employment: {
      full_time: '정규직',
      part_time: '시간제',
      contract: '계약직',
      internship: '인턴',
      temporary: '임시직'
    }
  },
  news: {
    other: '다른 소식'
  },
  coverage: {
    hint: '아이막을 선택하면 상세 정보가 표시됩니다.',
    province: '아이막',
    district: '구',
    customer: '거래처',
    contracted: '계약',
    zone: '권역',
    total: '합계',
    mapLabel: '몽골 아이막별 영업 범위'
  },
  contact: {
    name: '이름',
    company: '회사',
    email: '이메일',
    phone: '전화',
    subject: '제목',
    message: '메시지',
    namePlaceholder: '성함',
    companyPlaceholder: '회사명',
    subjectPlaceholder: '협업 문의',
    reachHint: '이메일 또는 전화번호 중 하나는 반드시 입력해 주세요.',
    submit: '보내기',
    sending: '보내는 중...',
    thanks: '감사합니다!',
    error: '메시지를 보내지 못했습니다. 다시 시도해 주세요.'
  },
  /*
   * АЖЛЫН БАЙРНЫ АНКЕТ.
   *
   * ⚠️ ГУРВАН ХЭЛЭНД ЧХ МОНГОЛООР — ЗОРИУД. Хуучин Laravel маягт
   * (`/anket/create`) бүх зочинд монголоор үйлчилдэг байсан бөгөөд
   * анкетыг ХН монголоор уншиж, монголоор эргэж холбогддог. Орчуулга
   * нэмбэл өргөдөгч англиар бөглөж, ХН талд ойлгомжгүй болно.
   *
   * ⇒ Хэл нэмэх шийдвэр гарвал ЭНД гурвуулангийнх нь текстийг сольж,
   *   сервер талын валидацын мессежийг ч (`website-application.dto.ts`)
   *   хамт орчуулна.
   */
  apply: {
    title: 'Ажлын байрны анкет',
    subtitle: 'Бүх талбарыг бөглөх шаардлагагүй — одоор тэмдэглэснийг л заавал бөглөнө.',
    forJob: 'Сонгосон ажлын байр',
    personal: 'Хувийн мэдээлэл',
    lastName: 'Овог',
    firstName: 'Нэр',
    urgiinOvog: 'Ургийн овог',
    register: 'Регистр',
    gender: 'Хүйс',
    male: 'Эрэгтэй',
    female: 'Эмэгтэй',
    birthday: 'Төрсөн огноо',
    marital: 'Гэр бүлийн байдал',
    single: 'Гэрлээгүй',
    married: 'Гэрлэсэн',
    divorced: 'Салсан',
    widowed: 'Бэлэвсэн',
    choose: 'Сонгох...',
    contactSection: 'Холбоо барих',
    mobilePhone: 'Гар утас',
    email: 'Имэйл',
    address: 'Гэрийн хаяг',
    emergencyContact: 'Яаралтай үед холбоо барих',
    emergencyPhone: 'Яаралтай үеийн утас',
    request: 'Ажлын хүсэлт',
    expectedSalary: 'Хүсэж буй цалин (₮)',
    hasAcquaintance: 'Максимуст танил хүн ажилладаг',
    acquaintanceDescription: 'Танилын нэр, албан тушаал',
    hasDisability: 'Хөгжлийн бэрхшээлтэй',
    disabilityDescription: 'Тайлбар',
    education: 'Боловсрол',
    school: 'Сургууль',
    degree: 'Зэрэг',
    fieldOfStudy: 'Мэргэжил',
    startDate: 'Эхэлсэн',
    endDate: 'Дууссан',
    experience: 'Ажлын туршлага',
    company: 'Байгууллага',
    position: 'Албан тушаал',
    salary: 'Цалин',
    leavingReason: 'Гарсан шалтгаан',
    jobDescription: 'Гүйцэтгэсэн ажил',
    family: 'Гэр бүлийн байдал',
    fullName: 'Бүтэн нэр',
    relationship: 'Таны юу болох',
    birthDate: 'Төрсөн огноо',
    phone: 'Утас',
    occupation: 'Мэргэжил',
    attachments: 'Хавсралт',
    avatar: 'Зураг',
    avatarHint: 'JPG, PNG, WEBP · 5 МБ хүртэл',
    cv: 'CV файл',
    cvHint: 'Зөвхөн PDF · 5 МБ хүртэл',
    coverLetter: 'Нэмэлт тайлбар',
    addRow: 'Мөр нэмэх',
    removeRow: 'Мөр хасах',
    noRows: 'Мөр нэмэгдээгүй байна',
    submit: 'Анкет илгээх',
    sending: 'Илгээж байна...',
    thanks: 'Анкет хүлээн авлаа!',
    thanksHint: 'Хүний нөөцийн алба таны анкеттай танилцаад эргэн холбогдоно.',
    error: 'Анкет илгээхэд алдаа гарлаа. Дахин оролдоно уу.',
    backToCareers: 'Ажлын байрны жагсаалт руу'
  },
  footer: {
    tagline: '세계 최고의 브랜드를 몽골 소비자에게 전달하는 유통 네트워크.',
    copyright: 'MAXIMUS. 모든 권리 보유.',
    note: 'maximus.mn',
    social: '소셜'
  },
  notFound: {
    title: '페이지를 찾을 수 없습니다',
    description: '해당 페이지가 없거나 주소가 변경되었습니다.'
  }
}

const DICTIONARIES: Record<Locale, Dictionary> = { mn, en, ko }

export const dictionaryFor = (locale: Locale): Dictionary => DICTIONARIES[locale] ?? mn
